import React, { useCallback, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';

import {
  Tooltip,
  Button,
  IconButton,
  createStyles,
} from '@material-ui/core'
import * as XLSX from 'xlsx'
import { toast } from 'react-toastify'

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from '@material-ui/lab'

import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined'
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined'
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined'
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import CloseIcon from '@material-ui/icons/Close';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined'
import RotateRightOutlinedIcon from '@material-ui/icons/RotateRightOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: '4px',
    flexDirection: 'column',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
    backgroundColor: '#fff',
  },
  messageText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(43, 44, 53, 1)',
    flexGrow: 1,
  },
  noAudit: {
    textAlign: 'center',
    width: '100%',
    padding: '20px',
  },
  tabBar: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingLeft: 20,
    paddingRight: 21,
    borderBottom: '1px solid #D5D6DD',
  },
  tab: {
    height: 36,
    display: 'flex',
    alignItems: 'center',
    padding: '6px 8px',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    lineHeight: '24px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottom: '1px solid #C6C7D1',
    color: '#78798E',
    boxSizing: 'border-box',
    userSelect: 'none',
  },
  tabActive: {
    borderBottom: '1px solid #3F51B5',
    color: '#3F51B5',
  },
  commentBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 10,
  },
  topRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
  },
  commentAvatar: {
    height: 24,
    width: 24,
    fontSize: 11,
    fontWeight: 500,
    backgroundColor: '#5398E6',
    color: '#fff',
  },
  nameTimeWrap: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
    gap: 4,
  },
  commenterName: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: 1,
  },
  commentTime: {
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(117, 117, 117, 1)',
    lineHeight: 1,
  },
  bottomRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
  },
  leftIndent: { width: 24 },
  commentText: {
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: 1.5,
    width: '100%',
    minWidth: 0,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  actionBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 4,
    backgroundColor: 'rgba(63, 81, 181, 0.08)',
    color: '#3F51B5',
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  },
  noCommentsText: {
    fontWeight: 400,
    fontSize: 12,
    color: 'rgba(120, 121, 142, 1)',
    textAlign: 'center',
    padding: '20px 0',
  },
}));

const useAuditTrailsStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      height: 'calc(100vh - 232px)',
    },
    opposite: {
      padding: '0px !important',
      color: '#78798E',
      fontSize: '0.75rem',
      minWidth: 180,
      flex: 0.2,
      textAlign: 'left',
      alignContent: 'center'
    },
    title: {
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      color: '#2B2C35',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      display: 'block',
    },
    subtitle: {
      marginTop: 8,
      color: '#78798E',
      fontSize: '0.75rem'
    },
    connector: {
      width: 1,
      background: 'linear-gradient(180deg, #D5D6DD 60%, transparent 40%)',
      backgroundSize: '2px 8px'
    },
    content: {
      textAlign: 'left',
      minWidth: 0,
    },
    dot: {
      height: '1.5rem',
      width: '1.5rem',
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%'
    }
  })
)

const getIcon = ({ operation, formName, formType }) => {
  let icon
  let bgColor

  switch (true) {
    case operation === 'process':
      bgColor = '#7A00FF'
      icon = <SettingsOutlinedIcon />
      break

    case operation === 'Created':
      bgColor = '#7A00FF'
      icon = <SettingsOutlinedIcon />
      break

    case operation === 'Accept':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Complete':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Init':
      bgColor = '#3082AA'
      icon = <RotateRightOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'ReInit':
      bgColor = '#0095FF'
      icon = <AutorenewOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Comment':
      bgColor = '#8E8E8E'
      icon = <ChatOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Execute':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Reject':
      bgColor = '#F52F55'
      icon = <ClearOutlinedIcon />
      break

    case operation === 'rejectObligation':
      bgColor = '#F52F55'
      icon = <ClearOutlinedIcon />
      break

    case operation === 'Update':
      bgColor = '#ED6A30'
      icon = <EditOutlinedIcon />
      break

    case operation === 'Assign document':
      bgColor = '#FEAD2C'
      icon = <PersonAddOutlinedIcon />
      break

    case operation === 'Moved':
      bgColor = '#523FFF'
      icon = <ArrowForwardOutlinedIcon />
      break

    case operation === 'Upload':
      bgColor = '#FF3FEC'
      icon = <ArrowUpwardOutlinedIcon />
      break

    case operation === 'filesplit':
      bgColor = '#BF00FF'
      icon = <FileCopyOutlinedIcon />
      break

    case operation === 'UnLocked':
      bgColor = '#27B47C'
      icon = <LockOpenOutlinedIcon />
      break

    case operation === 'Restore':
      bgColor = '#C7317E'
      icon = <HistoryOutlinedIcon />
      break

    case operation === 'Locked':
      bgColor = '#526172'
      icon = <LockOutlinedIcon />
      break

    case operation === 'Delete':
      bgColor = '#FE2C2C'
      icon = <CloseIcon />
      break

    default:
      bgColor = '#f5f5f5'
      icon = '🔄'
  }

  return {
    icon,
    bgColor
  }
}

const EventItem = (props) => {
  const { e, last } = props
  const classes = useAuditTrailsStyles()

  const legend = getIcon({
    operation: e?.operation,
    formName: e?.formName,
    formType: e?.formType
  })

  return (
    <TimelineItem>
      <TimelineOppositeContent className={classes.opposite}>
        {new Date(e.createdDate?.trim()).toLocaleString()}
      </TimelineOppositeContent>
      <TimelineSeparator style={{ marginTop: '0px' }}>
        <TimelineDot
          className={classes.dot}
          style={{ backgroundColor: legend?.bgColor }}
        >
          {legend?.icon}
        </TimelineDot>
        {!last && <TimelineConnector className={classes.connector} />}
      </TimelineSeparator>
      <TimelineContent className={classes.content}>
        <Tooltip title={e.message}>
          <Typography className={classes.title}>{e.message}</Typography>
        </Tooltip>
        <Typography className={classes.subtitle}>By {e.userName}</Typography>
      </TimelineContent>
    </TimelineItem>
  )
}

const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

const getTimeAgo = (dateString) => {
  if (!dateString) return '';
  const now = new Date();
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const diffMs = now - date;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);

  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  } else if (diffDays < 7) {
    return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  } else {
    return `${diffWeeks}w`;
  }
};

const CommentItem = ({ comment, classes, dateKey }) => {
  const byField = comment?.by;
  const name = (typeof byField === 'object' && byField !== null) ? (byField?.name || '') : (byField || '');
  const dateVal = comment?.[dateKey] || comment?.datetime || comment?.date || '';
  const action = comment?.action || '';

  return (
    <div className={classes.commentBlock}>
      <div className={classes.topRow}>
        <Avatar className={classes.commentAvatar}>
          {getInitials(name)}
        </Avatar>
        <div className={classes.nameTimeWrap}>
          <Typography className={classes.commenterName}>
            {name}
          </Typography>
          <Typography className={classes.commentTime}>
            {getTimeAgo(dateVal)}
          </Typography>
          {action ? (
            <span className={classes.actionBadge}>{action}</span>
          ) : null}
        </div>
      </div>
      <div className={classes.bottomRow}>
        <div className={classes.leftIndent} />
        <div style={{ flexGrow: 1, minWidth: 0, width: '100%' }}>
          <Typography className={classes.commentText} component="div">
            {comment?.comment ?? comment?.text ?? comment?.value ?? ''}
          </Typography>
        </div>
      </div>
    </div>
  );
};

const TABS = [
  { key: 'auditTrails', label: 'Audit Trails' },
  { key: 'comments', label: 'Comments' },
  { key: 'supplementaryComments', label: 'Supplementary Comments' },
];

const AuditTrailViewer = (props) => {
  const { auditTrail, chartUniqueId, isGobalDownloadEnable, onGlobalDownload, globalDownloadTitle, auditTrailDownloadInfo, isGlobalDownloadEnable, blockState } = props;
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState('auditTrails');

  const workflowComments = Array.isArray(blockState?.workflowComments) ? blockState.workflowComments : [];
  const supplementalInfoComments = Array.isArray(blockState?.supplementalInformationComments) ? blockState.supplementalInformationComments : [];

  const info = auditTrailDownloadInfo || {}
  const hasAuditRows = Array.isArray(auditTrail) && auditTrail.length > 0
  const downloadNotDisabledByConfig =
    info.isGlobalDownloadEnable !== false &&
    info.isGobalDownloadEnable !== false &&
    isGlobalDownloadEnable !== false &&
    isGobalDownloadEnable !== false
  const globalDownloadOn =
    hasAuditRows &&
    downloadNotDisabledByConfig &&
    (typeof onGlobalDownload === 'function' || onGlobalDownload == null)
  const downloadTooltipTitle =
    globalDownloadTitle ||
    info.globalDownloadTitle ||
    info.downloadTitle ||
    'Download'

  const handleGlobalDownloadAuditExcel = useCallback(() => {
    const rows = Array.isArray(auditTrail) ? auditTrail : []
    if (rows.length === 0) {
      toast.info('No audit trail to download.')
      return
    }
    const i = auditTrailDownloadInfo || {}
    const dateLabel = i.downloadDateLabel || 'Date'
    const messageLabel = i.downloadMessageLabel || 'Message'
    const userLabel = i.downloadUserLabel || 'User'
    const operationLabel = i.downloadOperationLabel || 'Operation'
    const formNameLabel = i.downloadFormNameLabel || 'Form name'
    const formTypeLabel = i.downloadFormTypeLabel || 'Form type'
    const headerRow = [dateLabel, messageLabel, userLabel, operationLabel, formNameLabel, formTypeLabel]
    const dataRows = rows.map((e) => {
      const rawDate = e?.createdDate
      const dateStr =
        rawDate != null && String(rawDate).trim() !== ''
          ? new Date(String(rawDate).trim()).toLocaleString()
          : ''
      return [
        dateStr,
        e?.message != null ? String(e.message) : '',
        e?.userName != null ? String(e.userName) : '',
        e?.operation != null ? String(e.operation) : '',
        e?.formName != null ? String(e.formName) : '',
        e?.formType != null ? String(e.formType) : '',
      ]
    })
    const sheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows])
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, sheet, 'Audit trail')
    const rawTitle = i.exportFileTitle || i.title || 'audit_trail'
    const safeName = String(rawTitle).replace(/[^\w\-]+/g, '_').slice(0, 80) || 'audit_trail'
    XLSX.writeFile(wb, `${safeName}.xlsx`)
  }, [auditTrail, auditTrailDownloadInfo])

  const handleDownloadClick = () => {
    handleGlobalDownloadAuditExcel()
  }

  const handleDownloadComments = useCallback(() => {
    if (workflowComments.length === 0) {
      toast.info('No comments to download.')
      return
    }
    const headerRow = ['Date & Time', 'Comment', 'By', 'Action']
    const dataRows = workflowComments.map((c) => {
      const byField = c?.by
      const name = (typeof byField === 'object' && byField !== null) ? (byField?.name || '') : (byField || '')
      const dateVal = c?.datetime || c?.date || ''
      const dateStr = dateVal ? new Date(dateVal).toLocaleString() : ''
      return [dateStr, c?.comment || '', name, c?.action || '']
    })
    const sheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows])
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, sheet, 'Comments')
    XLSX.writeFile(wb, 'workflow_comments.xlsx')
  }, [workflowComments])

  const handleDownloadSupplementaryComments = useCallback(() => {
    if (supplementalInfoComments.length === 0) {
      toast.info('No supplementary comments to download.')
      return
    }
    const headerRow = ['Date', 'Comment', 'By']
    const dataRows = supplementalInfoComments.map((c) => {
      const byField = c?.by
      const name = (typeof byField === 'object' && byField !== null) ? (byField?.name || '') : (byField || '')
      const dateVal = c?.date || c?.datetime || ''
      const dateStr = dateVal ? new Date(dateVal).toLocaleString() : ''
      return [dateStr, c?.comment || '', name]
    })
    const sheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows])
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, sheet, 'Supplementary Comments')
    XLSX.writeFile(wb, 'supplementary_comments.xlsx')
  }, [supplementalInfoComments])

  const renderAuditTrailsContent = () => (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderBottom: '1px solid #E0E0E0' }}>
        <Typography style={{ fontSize: '14px', fontWeight: '500', color: 'rgba(43, 44, 53, 1)', lineHeight: '21px' }}>
          Audit trails
        </Typography>
        {globalDownloadOn ? (
          <Tooltip title={downloadTooltipTitle}>
            <IconButton
              size="small"
              aria-label={downloadTooltipTitle}
              onClick={handleDownloadClick}
              style={{ padding: 4 }}
            >
              <img
                src="/media/createStepper/downloadIconNew.svg"
                alt=""
                style={{ width: 18, height: 18, display: 'block' }}
              />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      <div style={{ padding: '10px 16px', boxSizing: 'border-box', flex: 1, overflowY: 'auto' }}>
        {props.formData?.[chartUniqueId + '_audit_Trails_Obligations_loading'] ? (
          props.loader
        ) : auditTrail && auditTrail.length > 0 ? (
          <Timeline align='left' style={{ padding: '0px' }}>
            {auditTrail.map((res, index) => (
              <EventItem
                key={`auditlog-${res._id}`}
                e={res}
                last={index === auditTrail.length - 1}
              />
            ))}
          </Timeline>
        ) : (
          <Typography className={`${classes.messageText} ${classes.noAudit}`}>
            No audit history available yet.
          </Typography>
        )}
      </div>
    </>
  );

  const renderCommentsContent = () => (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderBottom: '1px solid #E0E0E0' }}>
        <Typography style={{ fontSize: '14px', fontWeight: '500', color: 'rgba(43, 44, 53, 1)', lineHeight: '21px' }}>
          Comments
        </Typography>
        {workflowComments.length > 0 ? (
          <Tooltip title="Download Comments">
            <IconButton
              size="small"
              aria-label="Download Comments"
              onClick={handleDownloadComments}
              style={{ padding: 4 }}
            >
              <img
                src="/media/createStepper/downloadIconNew.svg"
                alt=""
                style={{ width: 18, height: 18, display: 'block' }}
              />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      <div style={{ padding: '16px', boxSizing: 'border-box', flex: 1, overflowY: 'auto' }}>
        {workflowComments.length > 0 ? (
          workflowComments.map((comment, index) => (
            <CommentItem
              key={`wf-comment-${index}`}
              comment={comment}
              classes={classes}
              dateKey="datetime"
            />
          ))
        ) : (
          <Typography className={classes.noCommentsText}>
            No comments to show
          </Typography>
        )}
      </div>
    </>
  );

  const renderSupplementaryCommentsContent = () => (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderBottom: '1px solid #E0E0E0' }}>
        <Typography style={{ fontSize: '14px', fontWeight: '500', color: 'rgba(43, 44, 53, 1)', lineHeight: '21px' }}>
          Supplementary Comments
        </Typography>
        {supplementalInfoComments.length > 0 ? (
          <Tooltip title="Download Supplementary Comments">
            <IconButton
              size="small"
              aria-label="Download Supplementary Comments"
              onClick={handleDownloadSupplementaryComments}
              style={{ padding: 4 }}
            >
              <img
                src="/media/createStepper/downloadIconNew.svg"
                alt=""
                style={{ width: 18, height: 18, display: 'block' }}
              />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      <div style={{ padding: '16px', boxSizing: 'border-box', flex: 1, overflowY: 'auto' }}>
        {supplementalInfoComments.length > 0 ? (
          supplementalInfoComments.map((comment, index) => (
            <CommentItem
              key={`suppl-comment-${index}`}
              comment={comment}
              classes={classes}
              dateKey="date"
            />
          ))
        ) : (
          <Typography className={classes.noCommentsText}>
            No supplementary comments to show
          </Typography>
        )}
      </div>
    </>
  );

  return (
    <div className={`${classes.container} myScrollContainer`} style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 10 }}>
      <div className={classes.tabBar}>
        {TABS.map((tab) => (
          <div
            key={tab.key}
            className={`${classes.tab} ${activeTab === tab.key ? classes.tabActive : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {activeTab === 'auditTrails' && renderAuditTrailsContent()}
      {activeTab === 'comments' && renderCommentsContent()}
      {activeTab === 'supplementaryComments' && renderSupplementaryCommentsContent()}

      <div style={{ height: '70px', boxSizing: 'border-box', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', borderTop: '1px solid #E0E0E0' }}>
        <Button
          style={{ color: '#3F51B5', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '12px', boxSizing: 'border-box' }}
          onClick={props.handleAuditTrailDrawerToggle}
        >
          Close
        </Button>
      </div>
    </div>
  );
}

export default AuditTrailViewer
